import { z } from 'zod';

export const toggleDocumentUnreadPostRequestSchema = z.object({ relative_keys: z.array(z.string()) });
